import React from 'react';

export const DeleteModalConfirmation = ({ name, assessmentTitle }) => ({
  myAssignments: (
    <React.Fragment>
      {`Are you sure you want to remove the ${name} label from ${assessmentTitle}?`}
      <br />
    </React.Fragment>
  ),
});
